import axios from 'axios';

//App Settings
import { fullApiUrl } from '../utils/NetworkSettings';

class RestApi {
  constructor() {
    const instance = axios.create({
      baseURL: fullApiUrl,
      headers: {
        'X-Token-Key': 'covid-19'
      }
    });

    this.state = {
      restApi: instance
    };
  }

  GET(requestUrl) {
    return this.state.restApi
      .get(requestUrl)
      .then(response => {
        if (response.error) {
          throw response.error.message;
        } else {
          return response.data;
        }
      })
      .catch(err => {
        if (err.response.status === 401) {
          this.logOutAdmin();
        } else {
          throw err;
        }
      });
  }

  POST(requestUrl, params) {
    return this.state.restApi
      .post(requestUrl, params)
      .then(response => {
        if (response.error) {
          throw response.error.message;
        } else {
          return response.data;
        }
      })
      .catch(err => {
        if (err.response.status === 401) {
          this.logOutAdmin();
        } else {
          throw err;
        }
      });
  }

  PUT(requestUrl, params) {
    return this.state.restApi
      .put(requestUrl, params)
      .then(response => {
        if (response.error) {
          throw response.error.message;
        } else {
          return response.data;
        }
      })
      .catch(err => {
        if (err.response.status === 401) {
          this.logOutAdmin();
        } else {
          throw err;
        }
      });
  }

  DELETE(requestUrl) {
    return this.state.restApi
      .delete(requestUrl)
      .then(response => {
        if (response.error) {
          throw response.error.message;
        } else {
          return response.data;
        }
      })
      .catch(err => {
        if (err.response.status === 401) {
          this.logOutAdmin();
        } else {
          throw err;
        }
      });
  }

  EXTERNALGET(requestUrl) {
    return this.state.restApi
      .get(requestUrl)
      .then(response => {
        if (response.error) {
          throw response.error.message;
        } else {
          return response.data;
        }
      })
      .catch(err => {
        if (err.response.status === 401) {
          this.logOutAdmin();
        } else {
          throw err;
        }
      });
  }

  EXTERNALPOST(requestUrl, params) {
    return this.state.restApi
      .post(requestUrl, params)
      .then(response => {
        if (response.error) {
          throw response.error.message;
        } else {
          return response.data;
        }
      })
      .catch(err => {
        throw err;
      });
  }
}

export default RestApi;
